import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/styles/Categories.css";
import {
  Trophy,
  BookOpen,
  Gamepad2,
  Dumbbell,
  CalendarClock,
  Sparkles,
  BicepsFlexed,
  Shield,
} from "lucide-react";
import ChatbotButton from "../../components/common/ChatbotButton";

export default function Categories() {
  const navigate = useNavigate();

  // تم تعديل المصفوفة لتشمل العربي والإنجليزي لكل قسم
  const categories = [
    {
      id: "sports-schedule",
      nameAr: "حجز الملاعب",
      nameEn: "Court Booking",
      descAr:
        "احجز مكانك الآن! احجز ملاعب كرة القدم، السلة، أو الطائرة للعب مع أصدقائك.",
      descEn:
        "Reserve your spot now! Book Football, Basketball, or Volleyball courts to play matches with your friends.",
      icon: <CalendarClock size={40} />,
    },
    {
      id: "gym-status",
      nameAr: "مواعيد الجيم",
      nameEn: "Gym Schedule",
      descAr:
        "تحقق من المواعيد المتاحة للطلاب والطالبات وتأكد إذا كان الجيم مفتوحاً الآن.",
      descEn:
        "Check availability! Find out the dedicated hours for Men & Women and see if the Gym is open for you now.",
      icon: <BicepsFlexed size={40} />,
    },
    {
      id: "sports",
      nameAr: "الفعاليات الرياضية",
      nameEn: "Sports Events",
      descAr:
        "انضم للأنشطة الرياضية المنظمة مثل الماراثون والمعسكرات. سجل للمنافسة وحافظ على نشاطك.",
      descEn:
        "Join organized sports activities like marathons and training camps. Register to compete and stay active.",
      icon: <Dumbbell size={40} />,
    },
    {
      id: "academic",
      nameAr: "الفعاليات الأكاديمية",
      nameEn: "Academic Events",
      descAr:
        "طور مهاراتك من خلال التسجيل في ورش العمل والندوات والجلسات التعليمية في الحرم الجامعي.",
      descEn:
        "Enhance your skills by registering for workshops, seminars, and educational sessions on campus.",
      icon: <BookOpen size={40} />,
    },
    {
      id: "entertainment",
      nameAr: "الأنشطة الترفيهية",
      nameEn: "Entertainment",
      descAr:
        "خذ استراحة! اشترك في الرحلات والحفلات واللقاءات الترفيهية للتواصل مع زملائك.",
      descEn:
        "Take a break! Sign up for trips, concerts, and fun social gatherings to connect with other students.",
      icon: <Gamepad2 size={40} />,
    },
    {
      id: "competitions",
      nameAr: "المسابقات والتحديات",
      nameEn: "Competitions",
      descAr:
        "مستعد للفوز؟ سجل في التحديات المتنوعة واعرض مواهبك واربح الجوائز.",
      descEn:
        "Ready to win? Register for various challenges and contests to showcase your talents and earn rewards.",
      icon: <Trophy size={40} />,
    },
    {
      id: "military-education",
      nameAr: "التربية العسكرية",
      nameEn: "Military Education",
      descAr:
        "اقرأ تعليمات التربية العسكرية واملأ بياناتك لاستكمال تسجيل الدورة بنجاح.",
      descEn:
        "Read the Military Education guidelines and fill in your details to complete your registration.",
      icon: <Shield size={40} />,
    },
  ];

  return (
    <div style={{ marginTop: "60px" }} className="categories-wrapper">
      {/* Background Orbs */}
      <div className="background-wrapper">
        <div className="orb orb-1"></div>
        <div className="orb orb-2"></div>
      </div>

      <div className="container position-relative z-2">
        {/* Header Section */}
        <div className="text-center section-header">
          <div className="d-flex justify-content-center align-items-center gap-2 mb-3">
            <Sparkles size={24} className="text-info" />
            <span className="text-info fw-bold small tracking-wider text-uppercase">
              استكشف | Discover
            </span>
          </div>

          {/* العنوان ثنائي اللغة */}
          <div className="mb-4">
            <h1 className="title-gradient mb-1" dir="rtl">
              الأقسام والأنشطة
            </h1>
            <h2
              className="title-gradient"
              dir="ltr"
              style={{ fontSize: "1.5rem", opacity: 0.7 }}
            >
              Explore Categories
            </h2>
          </div>

          {/* الوصف ثنائي اللغة */}
          <div
            className="text-secondary mx-auto d-flex flex-column gap-2"
            style={{ maxWidth: "600px" }}
          >
            <p
              className="mb-0 fw-medium text-white"
              dir="rtl"
              style={{ fontSize: "1.1rem" }}
            >
              سواء كنت تريد حجز ملعب أو الانضمام إلى فعالية، وفرنا لك كل ما
              تحتاجه في مكان واحد.
            </p>
            <p
              className="mb-0"
              dir="ltr"
              style={{ fontSize: "0.95rem", opacity: 0.7 }}
            >
              Whether you want to book a court or join an event, we have it all
              covered for you.
            </p>
          </div>
        </div>

        {/* Cards Grid */}
        <div className="row g-4 justify-content-center">
          {categories.map((cat) => (
            <div key={cat.id} className="col-12 col-sm-6 col-lg-4">
              <div
                className="category-card-advanced h-100"
                onClick={() => navigate(`/activities/categories/${cat.id}`)}
              >
                {/* Icon Circle */}
                <div className="cat-icon-box">{cat.icon}</div>

                {/* Text Content - ثنائي اللغة */}
                <div className="w-100 d-flex flex-column gap-3">
                  {/* Titles */}
                  <div className="cat-title d-flex flex-column gap-1 mb-0">
                    <span dir="rtl" className="fw-bold">
                      {cat.nameAr}
                    </span>
                    <span
                      dir="ltr"
                      style={{
                        fontSize: "0.9rem",
                        opacity: 0.6,
                        fontWeight: "500",
                      }}
                    >
                      {cat.nameEn}
                    </span>
                  </div>

                  {/* Descriptions */}
                  <div className="cat-desc d-flex flex-column gap-2">
                    <span dir="rtl" style={{ color: "#e2e8f0" }}>
                      {cat.descAr}
                    </span>
                    <hr className="m-0 border-secondary opacity-25 w-50 mx-auto" />
                    <span
                      dir="ltr"
                      style={{ fontSize: "0.85rem", opacity: 0.6 }}
                    >
                      {cat.descEn}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <ChatbotButton />
    </div>
  );
}

// import { useNavigate } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../../assets/styles/Categories.css";
// import {
//   Trophy,
//   BookOpen,
//   Gamepad2,
//   Dumbbell,
//   CalendarClock,
//   Sparkles,
//   BicepsFlexed,
//   Shield,
// } from "lucide-react";
// import ChatbotButton from "../../components/common/ChatbotButton";

// export default function Categories() {
//   const navigate = useNavigate();

//   // تم تعديل الوصف ليعكس الفرق بين الحجز والأنشطة
//   const categories = [
//     {
//       id: "sports-schedule",
//       name: "Court Booking", // غيرت الاسم ليكون أوضح (حجز ملاعب) وممكن ترجعه Sports Schedule لو حابب
//       desc: "Reserve your spot now! Book Football, Basketball, or Volleyball courts to play matches with your friends.",
//       icon: <CalendarClock size={40} />,
//     },
//     {
//       id: "gym-status", // الرابط ده هيروح لصفحة بتعمل Check على الوقت والنوع
//       name: "Gym Schedule",
//       desc: "Check availability! Find out the dedicated hours for Men & Women and see if the Gym is open for you now.",
//       icon: <BicepsFlexed size={40} />,
//     },
//     {
//       id: "sports",
//       name: "Sports Events",
//       desc: "Join organized sports activities like marathons and training camps. Register to compete and stay active.",
//       icon: <Dumbbell size={40} />,
//     },
//     {
//       id: "academic",
//       name: "Academic Events",
//       desc: "Enhance your skills by registering for workshops, seminars, and educational sessions on campus.",
//       icon: <BookOpen size={40} />,
//     },
//     {
//       id: "entertainment",
//       name: "Entertainment",
//       desc: "Take a break! Sign up for trips, concerts, and fun social gatherings to connect with other students.",
//       icon: <Gamepad2 size={40} />,
//     },
//     {
//       id: "competitions",
//       name: "Competitions",
//       desc: "Ready to win? Register for various challenges and contests to showcase your talents and earn rewards.",
//       icon: <Trophy size={40} />,
//     },
//     {
//       id: "military-education",
//       name: "Military Education",
//       desc: "Read the Military Education guidelines and fill in your details to complete your registration.",
//       icon: <Shield size={40} />,
//     },
//   ];

//   return (
//     <div style={{ marginTop: "60px" }} className="categories-wrapper">
//       {/* Background Orbs */}
//       <div className="background-wrapper">
//         <div className="orb orb-1"></div>
//         <div className="orb orb-2"></div>
//       </div>

//       <div className="container position-relative z-2">
//         {/* Header Section */}
//         <div className="text-center section-header">
//           <div className="d-flex justify-content-center align-items-center gap-2 mb-2">
//             <Sparkles size={24} className="text-info" />
//             <span className="text-info fw-bold small tracking-wider text-uppercase">
//               Discover
//             </span>
//           </div>
//           <h1 className="title-gradient mb-3">Explore Categories</h1>
//           <p className="text-secondary mx-auto" style={{ maxWidth: "600px" }}>
//             Whether you want to book a court or join an event, we have it all
//             covered for you.
//           </p>
//         </div>

//         {/* Cards Grid */}
//         <div className="row g-4 justify-content-center">
//           {categories.map((cat) => (
//             <div key={cat.id} className="col-12 col-sm-6 col-lg-4">
//               <div
//                 className="category-card-advanced h-100"
//                 onClick={() => navigate(`/activities/categories/${cat.id}`)}
//               >
//                 {/* Icon Circle */}
//                 <div className="cat-icon-box">{cat.icon}</div>

//                 {/* Text Content */}
//                 <h3 className="cat-title">{cat.name}</h3>
//                 <p className="cat-desc">{cat.desc}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       <ChatbotButton />
//     </div>
//   );
// }
